import React, { useState, useRef } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Group } from 'types';
import { getAuthCookie } from "../../utils/authCookies";
interface Props {
  onGroupAdd: (newGroup: Group) => void;
  onClose: () => void;
}
const SignageAddGroup: React.FC<Props> = ({ onGroupAdd, onClose }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>("");
  const [formSubmitting, setFormSubmitting] = useState(false);
  const token = getAuthCookie("sessionToken");
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      groupName: '',
      statuss: 'Active',
      department: '',
      description: '',
      isInternal: false,
    },
    validationSchema: Yup.object({
      groupName: Yup.string()
        .min(2, 'Group name must be at least 2 characters long')
        .max(50, 'Group name cannot be longer than 50 characters')
        .required('Group Name is required'),
      // statuss: Yup.string()
      //   .required('Status is required'),
    }),
    onSubmit: async (values) => {
      console.log("Submitting form...", values);
      setFormSubmitting(true);
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/customer-groups`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              name: values.groupName || "",
              payment_after_days: 0,
              allow_partial_pay: false,
              max_credit_limit: 0,
              discount_percent: 0,
              allowed_user_ids: null,
              status: values.statuss,
              domain: values.department || "",
              purpose: values.description || "",
              audience: values.isInternal ? "external" : "external",
            }),
          }
        );

        if (!response.ok) {
          throw new Error("Failed to save data");
        }

        const result = await response.json();

        onGroupAdd(result);                         // ✅ update parent
        toast.success("Group added successfully!");

        if (onClose) onClose();                     // ✅ close modal here

      } catch (err) {
        console.error(err instanceof Error ? err.message : "Unknown error");
        toast.error("Failed to add Group.");
      } finally {
        setFormSubmitting(false);
      }
    }

  });

  return (
    <div className="content">
      <motion.div
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
      >
        <div className="d-flex justify-content-between align-items-center mb-3 px-3 pt-3">
          <h5 className="modal-title fw-bold">Add Group</h5>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onClose} // ✅ use the passed function
          ></button>
        </div>

        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-12">
            <div className="card shadow rounded-4 border-0">
              <div className="card-body p-4">
                <form onSubmit={formik.handleSubmit}>
                  <div className="row g-3 align-items-end">
                    {/* Group Name */}
                    <div className="col-md-12">
                      <label htmlFor="groupName" className="form-label fw-semibold">
                        Group Name <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control rounded-3 br-8"
                        id="groupName"
                        name="groupName"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.groupName}
                      />
                      {formik.touched.groupName && formik.errors.groupName && (
                        <div className="text-danger mt-1">{formik.errors.groupName}</div>
                      )}
                    </div>

                    {/* Department, Status and Type (same row) */}
                    {/* <div className="col-md-9">
                      <label htmlFor="department" className="form-label fw-semibold">
                        Department
                      </label>
                      <select
                        className="form-select rounded-3 br-8"
                        id="department"
                        name="department"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.department}
                      >
                        <option value="">- Select -</option>
                        <option value="admin">Admin</option>
                        <option value="front_desk">Front Desk</option>
                        <option value="accounting">Accounting</option>
                        <option value="installer">Installer</option>
                        <option value="operations">Operations</option>
                        <option value="warehouse">Warehouse</option>
                        <option value="design">Design</option>
                        <option value="marketing">Marketing</option>
                        <option value="legal">Legal</option>
                        <option value="management">Management</option>
                        <option value="sales">Sales</option>
                        <option value="hr">HR</option>
                        <option value="it">IT</option>
                        <option value="support">Support</option>
                        <option value="custom">Custom</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label fw-semibold d-block">Within organization</label>
                      <div className="form-check mt-1">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="isInternal"
                          name="isInternal"
                          onChange={formik.handleChange}
                          checked={formik.values.isInternal}
                          style={{ width: 18, height: 18, borderRadius: 4, appearance: 'auto' }}
                        />
                      </div>
                    </div> */}

                    {/* Description (full width row below) */}
                    <div className="col-md-12">
                      <label htmlFor="description" className="form-label fw-semibold mt-2">
                        Description
                      </label>
                      <textarea
                        id="description"
                        name="description"
                        className="form-control rounded-3 br-8"
                        rows={3}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.description}
                      />
                    </div>

                    {/* Status */}
                    <div className="col-md-12">
                      <label htmlFor="statuss" className="form-label fw-semibold">
                        {/* Status <span className="text-danger">*</span> */}
                        Status
                      </label>
                      <select
                        className="form-select rounded-3 br-8"
                        id="statuss"
                        name="statuss"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.statuss}
                      >
                        <option value="">- Select -</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                      {formik.touched.statuss && formik.errors.statuss && (
                        <div className="text-danger mt-1">{formik.errors.statuss}</div>
                      )}
                    </div>

                    {/* Footer buttons: Cancel left, Submit right */}
                    <div className="col-md-12 d-flex justify-content-between align-items-center mt-3">
                      <button
                        type="button"
                        className="btn back-btn surface-btn fw-bold fs-16"
                        onClick={onClose}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary table-addbutton"
                        type="submit"
                        disabled={formSubmitting}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default SignageAddGroup;